<footer class="footer">
  <div class="container">
    <div class="row">
      <nav class="col-md-6">
        <ul>
          <li>
            <a href="https://innporting.com/how-we-work" target="_blank">
              {{'FOOTER.HOW_WE_WORK' | translate}}
            </a>
          </li>
          <li>
            <a href="https://innporting.com/legal-notice-conditions" target="_blank">
              {{'FOOTER.TERMS_AND_CONDITIONS' | translate}}
            </a>
          </li>
          <!--<li>
            <a href="https://innporting.com/service-agreement" target="_blank">
              {{'FOOTER.SERVICE_AGREEMENT' | translate}}
            </a>
          </li>-->
        </ul>
      </nav>
      <div class="copyright col-md-6 padding-copyright">
        <p>
          &copy; {{date | date: 'yyyy'}} {{'FOOTER.MADE_BY' | translate}}
          <a href="https://innporting.com" target="_blank">{{'FOOTER.INNPORTING' | translate}}</a> {{'FOOTER.FOR_A_BETTER' | translate}}
        </p>
      </div>
    </div>
  </div>
</footer>
